const VERSION = 4;

//This should be called at the top of App.js.
export default function localStorageMigrate() {
   let oldVersion = 0;
   if (localStorage.getItem("version")) {
      oldVersion = localStorage.getItem("version");
   }
   //If oldVersion does not match new version
   if (oldVersion !== VERSION) {
      switch (oldVersion) {
         //Note: versions are strings in local storage because that's how local storage works.
         case "0":
            //No version found, clear local storage.
            localStorage.clear();
            break;
         case "1":
            localStorage.removeItem("installedApps");
            localStorage.removeItem("launchApp");
         case "2":
            localStorage.removeItem("installedApps");
            localStorage.removeItem("launchApp");
         case "3":
            localStorage.removeItem("userTheme");
            localStorage.setItem("userTheme", "Light");
         //See IDBConfig in the workers/IDBWorker directory for more notes
         //If you make changes to the structure of a value in localstorage, please
         //clear the key and increment the version forward.  I.E. You change
         //userTheme from a string to an object.  You would first turn the the version
         //to 2, the add:
         // case 1:
         //     localStorage.removeItem("userTheme")
         //You could even get more fancy and actually migrate the cache as well, if necessary.
         //for example:
         // case 1:
         //    const prevVal = localStorage.getItem("userTheme")
         //    localStorage.removeItem("userTheme")
         //    localStorage.setItem("userTheme", JSON.stringify({theme: prevVal, ...}))
         //Usually this will not be necessary, and can get overcomplicated, so for the most part,
         //follow the first example.
      }
      //Finally set the version key with new version, allowing us to compare when loading the next session.
      localStorage.setItem("version", VERSION);
   }
}
